/* istanbul ignore file */

export enum LinkStyle {
  BUTTONS = 'button',
  TEXT_LINKS = 'list',
  ARROW_LINKS = 'arrow_list',
  CLICKABLE_MODULE = 'module',
}
